import { Time } from "@angular/common";
import { ReportTypesUser } from "./AgencyMasterProperties";
import { ReportUserRightsProperties } from "./AgencyRightsProperties";
import { ActiveAirlines } from "./ActiveClasses";
export class UserStatisticsProps {
  totalUsers: number = 0;
  activeUsers: number = 0;
  inactiveUsers: number = 0;
}
export class UserRoles {
  userRoleId: number;
  roleName: string;
}
export class UsersProperties {
  userId: number = 0;
  agencyId: string = "";
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  loginName: string = "";
  password: string = "";
  email: string = "";
  mobile: string = "";
  telephone: string = "";
  designation: string = "";
  userRoleId: number = 0;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  status: boolean = true;
  isMasterAdmin: boolean = false;
  agency_branchId: string = "";
  branchId: string = "";
  isBranchAdmin: boolean = false;
  isAgencyAdmin: boolean = false;
  sessionToken: string = "";
  lastActivityTime: string = "";
  backSystemUserId: number = 0;
  isAgent: boolean = false;
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string;
  agentUser = new UserAgentRightsProperties();
  adminUser = new UserAdminControlRightsProperties();
  reportTypesRightsUser: ReportTypesUser[] = [];
  reportRightsUser: ReportUserRightsProperties[] = [];
  provinceId: number = 0;
  districtId: number = 0;
  tehsilId: number = 0;
  cityId: number = 0;
  townId: number = 0;
  accessDistrictsIds: string = "";
  isMainLoginAccount: boolean = false;
  assignedAirlines: string[] = [];
  userTicketIssueRightsPCCs = new UserTicketIssueRightsPCCs();
}
export class UserTicketIssueRightsPCCs {
  oneG = new OneGprops();
  oneGGDS = new OneGGDSprops();
  oneGNDC = new OneGNDCprops();
  indNDC = new IndNDCprops();
  lccs = new LCCsprops();
}
export class OneGprops {
  oneGRightStatus: boolean = false;
  oneG7KE2RightStatus: boolean = false;
  oneG84XHRightStatus: boolean = false;
  oneG8X4IRightStatus: boolean = false;
  oneGB2DRightStatus: boolean = false;
  oneG82QTRightStatus: boolean = false;
  oneG8K5XRightStatus: boolean = false;
  assignedAirlines1G7KE2: string[] = [];
  assignedAirlines1G84XH: string[] = [];
  assignedAirlines1G8X4I: string[] = [];
  assignedAirlines1GB2D: string[] = [];
  assignedAirlines1G82QT: string[] = [];
  assignedAirlines1G8K5X: string[] = [];
}
export class OneGGDSprops {
  oneGGDSRightStatus: boolean = false;
  oneGGDS8X4IRightStatus: boolean = false;
  oneGGDS8K5XRightStatus: boolean = false;
  oneGGDSB2DRightStatus: boolean = false;
  oneGGDS7KE2RightStatus: boolean = false;
  assignedAirlinesGDS8X4I: string[] = [];
  assignedAirlinesGDS8K5X: string[] = [];
  assignedAirlinesGDSB2D: string[] = [];
  assignedAirlinesGDS7KE2: string[] = [];
}
export class OneGNDCprops {
  oneGNDCRightStatus: boolean = false;
  oneGNDC8X4IRightStatus: boolean = false;
  oneGNDC8K5XRightStatus: boolean = false;
  oneGNDCB2DRightStatus: boolean = false;
  oneGNDC7KE2RightStatus: boolean = false;
  assignedAirlinesNDC8X4I: string[] = [];
  assignedAirlinesNDC8K5X: string[] = [];
  assignedAirlinesNDCB2D: string[] = [];
  assignedAirlinesNDC7KE2: string[] = [];
}
export class IndNDCprops {
  rightStatus: boolean = false;
  assignedAirlines: string[] = [];
}
export class LCCsprops {
  rightStatus: boolean = false;
  assignedAirlines: string[] = [];
}
export class LoginUserProperties {
  loginName: string = "";
  password: string = "";
  agencyId: string = "";
  isAuthorized: boolean;
  mobile: string = "";
  email: string = "";
  fullName: string = "";
  parentHierarchy: string = "";
  otp: string;
  otpTimeout: Time;
  toAuthorize: string;
  success: boolean;
  userId: number;
  parentAgency: string = "";
  immediateParent: string = "";
  userActive: boolean = false;
  secretKey: string = "";
  backSystemCompanyCustomer:string="";
  backSystemCompanyId:number;
  //20-jan-24
  agencyCurrency: string = "";
  oldPassword: string = "";
  //end
}
//export class UserAdminControlRightsProperties {
//  adminRightsId: number = 0
//  userId: number = 0;
//  profileUpdate: boolean = false;
//  supplierManagement: boolean = false;
//  beneficiaryAccount: boolean = false;
//  paymentProcess: boolean = false;
//  addPayment: boolean = false;
//  deletePayment: boolean = false;
//  approvePayment: boolean = false;
//  creditLimit: boolean = false;
//  notifications: boolean = false;
//  offlineRequest: boolean = false;
//  revenueManagement: boolean = false;
//  offlineSettings: boolean = false;
//  cms: boolean = false;
//  accountManagement: boolean = false;
//  account: boolean = false;
//  users: boolean = false;
//  logs: boolean = false;
//  currency: boolean = false;
//  bookings: boolean = false;
//  searchBookings: boolean = false;
//  viewBookings: boolean = false;
//  updateBookings: boolean = false;
//  creationUser: number = 0;
//  creationDate: string = "";
//  modifyUser: number = 0;
//  modifyDate: string = "";
//  dashboard: boolean = false;
//  reports: boolean = false;
//}

export class UserAdminControlRightsProperties {
  adminRightsId: number = 0
  userId: number = 0;
  profileUpdate: boolean = false;
  supplierManagement: boolean = false;
  beneficiaryAccount: boolean = false;
  paymentProcess: boolean = false;
  addPayment: boolean = false;
  deletePayment: boolean = false;
  approvePayment: boolean = false;
  creditLimit: boolean = false;
  notifications: boolean = false;
  offlineRequest: boolean = false;
  revenueManagement: boolean = false;
  canEditRevenue: boolean = false;
  offlineSettings: boolean = false;
  cms: boolean = false;
  accountManagement: boolean = false;
  account: boolean = false;
  users: boolean = false;
  agencyManagement: boolean = false;
  canAddOrEditAgency: boolean = false;
  branchManagement: boolean = false;
  logs: boolean = false;
  currency: boolean = false;
  bookings: boolean = false;
  searchBookings: boolean = false;
  viewBookings: boolean = false;
  updateBookings: boolean = false;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  dashboard: boolean = false;
  reports: boolean = false;
  viewSubAgentBookings: boolean = false;
  issueTicket: boolean = false;
  cancelPNR: boolean = false;
  refund: boolean = false;
  importPNR: boolean = false;
  exchangeTicket: boolean = false;
  quotations: boolean = false;
  fareRules: boolean = false;
  voidTicket: boolean = false;
  offlineBooking: boolean = false;
  offlineTicket: boolean = false;
  offlineVoid: boolean = false;
  offlineRefund: boolean = false;
  offlineDealsByCMS: boolean = false;
  reportsManage: boolean = false;
  companyMasterRight:boolean=false;
  groupTicketRight:boolean=false;
  groupTicketCreateRight:boolean=false;
  groupTicketListRight:boolean=false;
  modifyBooking:boolean=false;
    //10-June-24
  groupTicketShowRight: boolean = false;
  insuranceRight: boolean = false;
  isRegisterBecomePartnerList: boolean = false;
  insuranceIssuanceRight: boolean = false;
  insuranceBookedViewRight: boolean = false;
  insuranceCancelRight: boolean = false;
  offlineManage: boolean = false;
  offlineManageRefund: boolean = false;
  offlineManageBooking: boolean = false;
  offlineManageTicket: boolean = false;
  offlineManageVoid: boolean = false;
  offlineManageResissue: boolean = false;
  offlineResissue: boolean = false;
}

export class UserAgentRightsProperties {
  userAgentRightsId: number = 0;
  userId: number = 0;
  quotations: boolean = false;
  book: boolean = false;
  issueTicket: boolean = false;
  issuePNR: boolean = false;
  cancelTicket: boolean = false;
  cancelPNR: boolean = false;
  voidTicket: boolean = false;
  fareRules_Result: boolean = false;
  offlineRequest: boolean = false;
  offlineBooking: boolean = false;
  reprice: boolean = false;
  markup: boolean = false;
  refund: boolean = false;
  offlineRefund: boolean = false;
  exchange: boolean = false;
  calenderSearch: boolean = false;
  recentSearch: boolean = false;
  adminPanelLogin: boolean = false;
  newBookings: boolean = false;
  myBookings: boolean = false;
  searchBookings: boolean = false;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  status: boolean = true;
}

export class LoginUserRights {
  userAdminRights = new UserAdminControlRightsProperties();
  userAgentRights = new UserAgentRightsProperties();
  checkBranchAdmin: boolean = false;
  checkAgent: boolean = false;
  checkAgencyAdmin: boolean = false;
}

//export class UserRightsDisabledProperties {

//  ad_isAdmin: boolean = false;
//  ad_isAgent: boolean = false;
//  ad_profileDisbled: boolean = false;
//  ad_supplierManagementDisabled: boolean = false;
//  ad_beneficiaryDisabled: boolean = false;
//  ad_paymentProcessDisabled: boolean = false;
//  ad_addPaymentDisabled: boolean = false;
//  ad_deletePaymentDisabled: boolean = false;
//  ad_approvePaymentDisabled: boolean = false;
//  ad_creditLimitDisabled: boolean = false;
//  ad_notificationsDisabled: boolean = false;
//  ad_offlineRequestDisabled: boolean = false;
//  ad_revenueDisabled: boolean = false;
//  ad_offlineSettingsDisabled: boolean = false;
//  ad_cmsDisabled: boolean = false;
//  ad_accountManagementDisabled: boolean = false;
//  ad_accountDisabled: boolean = false;
//  ad_usersDisabled: boolean = false;
//  ad_logsDisabled: boolean = false;
//  ad_currencyDisabled: boolean = false;
//  ad_bookingsDisabled: boolean = false;
//  ad_searchBookingsDisabled: boolean = false;
//  ad_viewBookingsDisabled: boolean = false;
//  ad_updateBookingsDisabled: boolean = false;
//  ad_dashboardDisabled: boolean = false;
//  ad_reportsDisabled: boolean = false;
//  //Agent Section
//  ag_quotationsDisabled: boolean = false;
//  ag_bookDisabled: boolean = false;
//  ag_issueTicketDisabled: boolean = false;
//  ag_issuePNRDisabled: boolean = false;
//  ag_cancelTicketDisabled: boolean = false;
//  ag_cancelPNRDisabled: boolean = false;
//  ag_voidTicketDisabled: boolean = false;
//  ag_fareRules_ResultDisabled: boolean = false;
//  ag_offlineRequestDisabled: boolean = false;
//  ag_offlineBookingDisabled: boolean = false;
//  ag_repriceDisabled: boolean = false;
//  ag_markupDisabled: boolean = false;
//  ag_refundDisabled: boolean = false;
//  ag_offlineRefundDisabled: boolean = false;
//  ag_exchangeDisabled: boolean = false;
//  ag_calenderSearchDisabled: boolean = false;
//  ag_recentSearchDisabled: boolean = false;
//  ag_adminPanelLoginDisabled: boolean = false;
//  ag_newBookingsDisabled: boolean = false;
//  ag_myBookingsDisabled: boolean = false;
//  ag_searchBookingsDisabled: boolean = false;
//}

export class UserRightsDisabledProperties {

  ad_isAdmin: boolean = false;
  ad_isAgent: boolean = false;
  ad_profileDisbled: boolean = false;
  ad_supplierManagementDisabled: boolean = false;
  ad_beneficiaryDisabled: boolean = false;
  ad_paymentProcessDisabled: boolean = false;
  ad_addPaymentDisabled: boolean = false;
  ad_deletePaymentDisabled: boolean = false;
  ad_approvePaymentDisabled: boolean = false;
  ad_creditLimitDisabled: boolean = false;
  ad_notificationsDisabled: boolean = false;
  ad_offlineRequestDisabled: boolean = false;
  ad_revenueDisabled: boolean = false;
  ad_offlineSettingsDisabled: boolean = false;
  ad_cmsDisabled: boolean = false;
  ad_accountManagementDisabled: boolean = false;
  ad_accountDisabled: boolean = false;
  ad_usersDisabled: boolean = false;
  ad_logsDisabled: boolean = false;
  ad_currencyDisabled: boolean = false;
  ad_bookingsDisabled: boolean = false;
  ad_searchBookingsDisabled: boolean = false;
  ad_viewBookingsDisabled: boolean = false;
  ad_updateBookingsDisabled: boolean = false;
  ad_dashboardDisabled: boolean = false;
  ad_reportsDisabled: boolean = false;
  //Agent Section
  ag_quotationsDisabled: boolean = false;
  ag_bookDisabled: boolean = false;
  ag_issueTicketDisabled: boolean = false;
  ag_issuePNRDisabled: boolean = false;
  ag_cancelTicketDisabled: boolean = false;
  ag_cancelPNRDisabled: boolean = false;
  ag_voidTicketDisabled: boolean = false;
  ag_fareRules_ResultDisabled: boolean = false;
  ag_offlineRequestDisabled: boolean = false;
  ag_offlineBookingDisabled: boolean = false;
  ag_repriceDisabled: boolean = false;
  ag_markupDisabled: boolean = false;
  ag_refundDisabled: boolean = false;
  ag_importPNR: boolean = false;
  // ag_offlineRefundDisabled: boolean = false;
  ag_exchangeDisabled: boolean = false;
  ag_calenderSearchDisabled: boolean = false;
  ag_recentSearchDisabled: boolean = false;
  ag_adminPanelLoginDisabled: boolean = false;
  ag_newBookingsDisabled: boolean = false;
  ag_myBookingsDisabled: boolean = false;
  ag_searchBookingsDisabled: boolean = false;
  ag_offlineBookingsDisabled: boolean = false;
  ag_offlineTicketDisabled: boolean = false;
  ag_offlineVoidDisabled: boolean = false;
  ag_offlineRefundDisabled: boolean = false;
  ag_offlineDealsDisabled: boolean = false;
  ag_viewSubAgentBooking: boolean = false;
  ag_reportsManage: boolean = false;
    ag_offlineManage: boolean;
    ag_offlineManageBooking: boolean;
    ag_offlineManageTicket: boolean;
    ag_offlineManageVoid: boolean;
    ag_offlineManageRefund: boolean;
    ag_offlineManageResissue: boolean;
}
export class Province {
  provinceId: number;
  provinceName: string;
}

export class District {
  districtId: number;
  provinceId: number;
  districtName: string;
}

export class Tehsil {
  tehsilId: number;
  districtId: number;
  tehsilName: string;
}

export class City {
  cityId: number;
  tehsilId: number;
  cityName: string;
}

export class Town {
  townId: number;
  cityId: number;
  townName: string;
}

export class GetAllProvinceDistrictTehsilCityTown {
  provinces: Province[];
  districts: District[];
  tehsils: Tehsil[];
  cities: City[];
  towns: Town[];
}

export class userBackCompanyCustomerCode {
  userId: number;
  companyName: string;
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string;
  immediateParent: string;
  agency_BranchId: string;
}
export class AssignedAirlinesForTicketIssueBaseData {
  userTicketIssueRightsPCCs: UserTicketIssueRightsPCCs;
  allAirlinesList: ActiveAirlines[] = [];
}

